import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, EventEmitter, input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICustomResumeCard } from '../../../../core/models/common/card-resume.interface';

@Component({
  selector: 'app-card-resume',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './card-resume.component.html',
  styleUrl: './card-resume.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class CardResumeComponent implements OnInit{
  readonly currentResume = input<string>('');
  readonly cardResumeData = input<Array<ICustomResumeCard>>([]);

  @Output() readonly onResumeClicked = new EventEmitter<string>();

  currentResumeSelected = '';

  constructor() {
    effect(() => {
      this.cardResumeData();
    })
  }

  ngOnInit(): void {
    this.currentResumeSelected = this.currentResume();
  }

  onSubmit(title: string): void {
    this.onResumeClicked.emit(title);
    this.currentResumeSelected = title;
  }
}
